import { z } from "zod";
import { GasLimitSchema } from "./enums/gas-limit";
import { bigNumberTransformer } from "./transformers/big-number-transformer";
export const PresetSettingsSchema = z.object({
  prio_fee: bigNumberTransformer.optional(),
  max_slippage: bigNumberTransformer.optional(),
  bribe_fee: bigNumberTransformer.optional(),
  mev_protection: z.boolean().optional(),
  gas_limit: GasLimitSchema.optional(),
});
export const PresetSchema = z.object({
  id: z.number(),
  title: z.string(),
  buy_settings: PresetSettingsSchema,
  sell_settings: PresetSettingsSchema,
});

export type Preset = z.infer<typeof PresetSchema>;

export const mockPresets: Preset[] = [
  {
    id: 1,
    title: "Preset 1",
    buy_settings: {
      prio_fee: 0.01,
      max_slippage: 0.005,
      bribe_fee: 0.02,
      mev_protection: true,
    },
    sell_settings: {
      prio_fee: 0.01,
      max_slippage: 0.0075,
      bribe_fee: 0.025,
      mev_protection: false,
    },
  },
  {
    id: 2,
    title: "Preset 2",

    buy_settings: {
      prio_fee: 0.01,
      max_slippage: 0.005,
      bribe_fee: 0.02,
      mev_protection: true,
    },
    sell_settings: {
      prio_fee: 0.01,
      max_slippage: 0.0075,
      bribe_fee: 0.025,
      mev_protection: false,
    },
  },
  {
    id: 3,
    title: "Preset 3",

    buy_settings: {
      prio_fee: 0.01,
      max_slippage: 0.005,
      bribe_fee: 0.02,
      mev_protection: true,
    },
    sell_settings: {
      prio_fee: 0.01,
      max_slippage: 0.0075,
      bribe_fee: 0.025,
      mev_protection: false,
    },
  },
];
